export const deepEqual = (a: object, b: object) => JSON.stringify(a) === JSON.stringify(b);
export const isSubObject = (a: object, b: object) => JSON.stringify(a) === JSON.stringify({ ...a, ...b});



// WEBPACK FOOTER //
// ./src/fp/index.ts